import React, { useCallback, useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { DrawerComponent } from 'components/Drawer';
import { api } from 'services/api';
import loadingSmall from 'assets/image/loading-small.gif';
import * as S from './styles';
import CardDrawer from './components/CardDrawer';
import { DownloadIcon, KenloLiaIcon } from 'components/Icons';
import PencilLIA from 'components/Icons/PincelLIA';
import moment from 'moment';
import 'moment/locale/pt-br';
import { theme } from 'styles/theme';
import { ToolTip } from 'components/ToolTip';
import { InvoiceStatus } from 'components/InvoiceStatus';
import Hands from 'components/Icons/hands';
interface IConsumptionDetails {
  closeDrawer: () => void;
  idConsumption: string | undefined;
  indicator: any;
  typeProduct: string;
  exceedingEnvelopes: any;
}
// Enum NumberTypeTransactionDebit
enum NumberTypeTransactionDebit {
  ZERA_FRANQUIA = 1,
  QUALIFIER = 2,
  EXPIRATION = 3,
  REVERSE = 4,
  SIGNATURE = 5,
  FACIAL_RECOGNITION = 6,
  FACIAL_RECOGNITION_SIGNATURE = 7,
  PROPERTY_DESCRIPTION = 8,
  PICTURE_EDITING = 9,
  CHATBOT = 10,
  POST = 11,
  VIDEO_GENERATION = 12,
  LANDING_PAGE = 13,
}

// Função para mapear o tipo de transação para a categoria
const mapTransactionTypeToCategory = (
  typeTransaction: number | string | undefined,
):
  | 'SDR'
  | 'Editor'
  | 'Studio'
  | 'Omnichannel'
  | 'Oráculo'
  | 'KIB'
  | undefined => {
  const type =
    typeof typeTransaction === 'string'
      ? parseInt(typeTransaction)
      : typeTransaction;

  if (type === NumberTypeTransactionDebit.CHATBOT) {
    return 'SDR';
  }
  if (
    type === NumberTypeTransactionDebit.PROPERTY_DESCRIPTION ||
    type === NumberTypeTransactionDebit.PICTURE_EDITING
  ) {
    return 'Editor';
  }
  if (type === NumberTypeTransactionDebit.VIDEO_GENERATION) {
    return 'Studio';
  }
  if (type === NumberTypeTransactionDebit.POST) {
    return 'Omnichannel';
  }
  if (type === NumberTypeTransactionDebit.LANDING_PAGE) {
    return 'KIB';
  }

  return undefined;
};

const iconColor = '#404040';

const categories = [
  {
    name: 'SDR',
    color: '#B5E4FF',
    key: 'qtd_sdr_lya',
    icon: (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M17.5 12C20.5376 12 23 14.4624 23 17.5C23 20.5376 20.5376 23 17.5 23C14.4624 23 12 20.5376 12 17.5C12 14.4624 14.4624 12 17.5 12ZM14.8536 17.1465C14.6583 16.9512 14.3417 16.9512 14.1464 17.1465C13.9512 17.3417 13.9512 17.6583 14.1464 17.8536L16.1464 19.8536C16.3417 20.0488 16.6583 20.0488 16.8536 19.8536L20.8536 15.8536C21.0488 15.6583 21.0488 15.3417 20.8536 15.1465C20.6583 14.9512 20.3417 14.9512 20.1464 15.1465L16.5 18.7929L14.8536 17.1465ZM12.0223 13.9993C11.7256 14.4626 11.486 14.966 11.3136 15.4996L4.25242 15.4999C3.83882 15.4999 3.50354 15.8352 3.50354 16.2488V16.8265C3.50354 17.3622 3.69465 17.8802 4.04251 18.2876C5.29582 19.7553 7.26169 20.5011 10 20.5011C10.5964 20.5011 11.1563 20.4657 11.6802 20.3952C11.9254 20.8901 12.233 21.3486 12.5917 21.7615C11.7962 21.9217 10.9314 22.0011 10 22.0011C6.85414 22.0011 4.46812 21.0959 2.90182 19.2617C2.32206 18.5828 2.00354 17.7193 2.00354 16.8265V16.2488C2.00354 15.0068 3.0104 13.9999 4.25242 13.9999L12.0223 13.9993ZM10 2.00464C12.7614 2.00464 15 4.24321 15 7.00464C15 9.76606 12.7614 12.0046 10 12.0046C7.23857 12.0046 5 9.76606 5 7.00464C5 4.24321 7.23857 2.00464 10 2.00464ZM10 3.50464C8.067 3.50464 6.5 5.07164 6.5 7.00464C6.5 8.93764 8.067 10.5046 10 10.5046C11.933 10.5046 13.5 8.93764 13.5 7.00464C13.5 5.07164 11.933 3.50464 10 3.50464Z'
          fill='#404040'
        />
      </svg>
    ),
    label: 'leads atendidos',
  },
  {
    name: 'Omnichannel',
    color: '#7CAEF1',
    key: 'qtd_omnichannel_lya',
    icon: (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M9.56158 3C5.41944 3 2.06158 6.35786 2.06158 10.5C2.06158 11.6329 2.31325 12.7088 2.76423 13.6734C2.5102 14.6714 2.22638 15.7842 2.03999 16.5147C1.80697 17.428 2.6294 18.2588 3.54374 18.039C4.29396 17.8587 5.44699 17.5819 6.47447 17.337C7.41678 17.7631 8.46241 18 9.56158 18C13.7037 18 17.0616 14.6421 17.0616 10.5C17.0616 6.35786 13.7037 3 9.56158 3ZM3.56158 10.5C3.56158 7.18629 6.24787 4.5 9.56158 4.5C12.8753 4.5 15.5616 7.18629 15.5616 10.5C15.5616 13.8137 12.8753 16.5 9.56158 16.5C8.60084 16.5 7.69487 16.2748 6.89161 15.8749L6.6482 15.7537L6.38368 15.8167C5.46095 16.0363 4.39489 16.2919 3.59592 16.4838C3.79467 15.7047 4.05784 14.6724 4.28601 13.7757L4.35619 13.4998L4.22568 13.2468C3.80145 12.4246 3.56158 11.4914 3.56158 10.5ZM14.5616 21.0001C12.5922 21.0001 10.8001 20.241 9.46191 18.9995C9.49511 18.9999 9.52835 19.0001 9.56163 19.0001C10.2796 19.0001 10.9768 18.911 11.6427 18.7434C12.5067 19.2254 13.5021 19.5001 14.5616 19.5001C15.5223 19.5001 16.4283 19.2748 17.2316 18.8749L17.475 18.7537L17.7395 18.8167C18.6611 19.0361 19.7046 19.2625 20.4787 19.4262C20.3037 18.6757 20.065 17.6711 19.8372 16.7757L19.767 16.4999L19.8975 16.2469C20.3217 15.4247 20.5616 14.4915 20.5616 13.5001C20.5616 11.3853 19.4676 9.52617 17.8146 8.45761C17.6363 7.73435 17.3653 7.04756 17.015 6.41052C19.9523 7.42684 22.0616 10.2171 22.0616 13.5001C22.0616 14.6332 21.8098 15.7094 21.3586 16.6741C21.6117 17.6821 21.8679 18.774 22.0304 19.4773C22.2348 20.3623 21.4554 21.1633 20.563 20.9768C19.8358 20.8248 18.6933 20.581 17.6495 20.3367C16.707 20.763 15.6611 21.0001 14.5616 21.0001Z'
          fill='#404040'
        />
      </svg>
    ),
    label: 'templates enviados',
  },
  {
    name: 'Oráculo',
    color: '#1F3A8A',
    key: 'qtd_oraculo_lya',
    icon: (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M12 2C13.1533 2 14.2391 2.28926 15.1888 2.79919C15.1125 3.245 14.9647 3.56044 14.7626 3.76256C14.652 3.87316 14.5074 3.96747 14.3259 4.04283C13.6241 3.69484 12.8348 3.5 12 3.5C9.10051 3.5 6.75 5.8505 6.75 8.75C6.75 10.8882 8.02822 12.7278 9.86222 13.5465C10.5503 13.815 11.1857 13.9625 11.7683 13.9937L12 14C12.6447 14 13.3575 13.8508 14.1372 13.5477C15.053 13.1384 15.8302 12.475 16.3789 11.6472C17.0183 11.8672 17.7877 11.7336 18.2728 11.2467C17.8577 12.2895 17.1902 13.2039 16.3459 13.9151L17.9673 18.7802C18.2336 19.5789 17.8933 20.4541 17.1573 20.8632C15.7856 21.6256 14.0643 22 12 22C9.93575 22 8.21443 21.6256 6.84269 20.8632C6.10675 20.4541 5.76645 19.579 6.0327 18.7802L7.65415 13.9151C6.18405 12.6769 5.25 10.8225 5.25 8.75C5.25 5.02208 8.27208 2 12 2ZM15.0566 14.7914L14.6969 14.9395L14.6788 14.9475C13.9523 15.262 13.1595 15.4525 12.3272 15.4922C12.321 15.4911 12.3153 15.4914 12.3096 15.4917C12.2858 15.4941 12.2614 15.4951 12.237 15.4959L12 15.5L11.804 15.496L11.6733 15.4908C10.8405 15.4525 10.0477 15.262 9.32116 14.9475L9.30307 14.9395C9.18403 14.893 9.06416 14.8436 8.94345 14.7914L7.45573 19.2545C7.41769 19.3686 7.46631 19.4937 7.57144 19.5521C8.70008 20.1794 10.174 20.5 12 20.5C13.826 20.5 15.2999 20.1794 16.4286 19.5521C16.5337 19.4937 16.5823 19.3686 16.5443 19.2545L15.0566 14.7914ZM11.6898 15.493L11.804 15.496L11.8373 15.4977L12 15.5C11.896 15.5 11.7926 15.4977 11.6898 15.493ZM17.9924 1.88021L18 2C18 3.14961 18.2699 3.95921 18.7803 4.46967C19.2515 4.94087 19.9776 5.20706 20.9907 5.24522L21.25 5.25C22.2083 5.25 22.2483 6.6276 21.3698 6.7424L21.25 6.75C20.1004 6.75 19.2908 7.01987 18.7803 7.53033C18.3091 8.00153 18.0429 8.72761 18.0048 9.74072L18 10C18 11 16.5 11 16.5 10C16.5 8.85039 16.2301 8.04079 15.7197 7.53033C15.2485 7.05913 14.5224 6.79294 13.5093 6.75478L13.25 6.75C12.2917 6.75 12.2517 5.3724 13.1302 5.2576L13.25 5.25C14.3996 5.25 15.2092 4.98013 15.7197 4.46967C16.2301 3.95921 16.5 3.14961 16.5 2C16.5 1.04167 17.8776 1.00174 17.9924 1.88021ZM17.25 4.95251L17.1063 5.15617C17.0063 5.28828 16.8976 5.41304 16.7803 5.53033C16.6044 5.70627 16.4116 5.86273 16.2025 6C16.4116 6.13727 16.6044 6.29373 16.7803 6.46967C16.9563 6.64561 17.1127 6.83835 17.25 7.04749C17.3873 6.83835 17.5437 6.64561 17.7197 6.46967C17.8956 6.29373 18.0884 6.13727 18.2975 6C18.0884 5.86273 17.8956 5.70627 17.7197 5.53033C17.6024 5.41304 17.4937 5.28828 17.3937 5.15617L17.25 4.95251Z'
          fill='#404040'
        />
      </svg>
    ),
    label: 'leads qualificados',
  },
  {
    name: 'Editor',
    color: '#514180',
    key: 'qtd_editor_lya',
    icon: <PencilLIA color={iconColor} />,
    label: 'descrições criadas',
  },
  {
    name: 'Studio',
    color: '#C876F2',
    key: 'qtd_studio_lya',
    icon: (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M9.5 9.38455V14.6162C9.5 15.1858 10.1099 15.5475 10.6097 15.2743L15.3959 12.6582C15.9163 12.3737 15.9162 11.6263 15.3958 11.3419L10.6097 8.72641C10.1099 8.45328 9.5 8.81499 9.5 9.38455ZM7.25 1C5.45507 1 4 2.45507 4 4.25V19.75C4 21.5449 5.45507 23 7.25 23H16.75C18.5449 23 20 21.5449 20 19.75V4.25C20 2.45507 18.5449 1 16.75 1H7.25ZM5.5 4.25C5.5 3.2835 6.2835 2.5 7.25 2.5H16.75C17.7165 2.5 18.5 3.2835 18.5 4.25V19.75C18.5 20.7165 17.7165 21.5 16.75 21.5H7.25C6.2835 21.5 5.5 20.7165 5.5 19.75V4.25Z'
          fill='#404040'
        />
      </svg>
    ),
    label: 'criações',
  },
  {
    name: 'KIB',
    color: '#F1C0FF',
    key: 'qtd_kib_lya',
    icon: (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M18 20.5H12.2678C11.9806 21.051 11.6168 21.5557 11.1904 22H18C19.104 22 20 21.104 20 20V9.828C20 9.298 19.789 8.789 19.414 8.414L13.585 2.586C13.57 2.57105 13.5531 2.55808 13.5363 2.5452C13.5238 2.53567 13.5115 2.5262 13.5 2.516C13.429 2.452 13.359 2.389 13.281 2.336C13.2557 2.31894 13.2281 2.30548 13.2005 2.29207C13.1845 2.28426 13.1685 2.27647 13.153 2.268C13.1363 2.25859 13.1197 2.24897 13.103 2.23933C13.0488 2.20797 12.9944 2.17648 12.937 2.152C12.74 2.07 12.528 2.029 12.313 2.014C12.2933 2.01274 12.2738 2.01008 12.2542 2.00741C12.2271 2.00371 12.1999 2 12.172 2H6C4.896 2 4 2.896 4 4V11.4982C4.47417 11.3004 4.97679 11.1572 5.5 11.0764V4C5.5 3.725 5.724 3.5 6 3.5H12V8C12 9.104 12.896 10 14 10H18.5V20C18.5 20.275 18.276 20.5 18 20.5ZM17.378 8.5H14C13.724 8.5 13.5 8.275 13.5 8V4.621L17.378 8.5ZM13 17.5C13 18.0163 12.9398 18.5185 12.8261 19H15.25C16.2165 19 17 18.2165 17 17.25V13.25C17 12.2835 16.2165 11.5 15.25 11.5H9.0044C9.97947 11.9075 10.8341 12.5457 11.5 13.3464V13H15.25C15.3881 13 15.5 13.1119 15.5 13.25V14.5H12.2678C12.5124 14.9693 12.7014 15.4722 12.8261 16H15.5V17.25C15.5 17.3881 15.3881 17.5 15.25 17.5H13ZM12 17.5C12 20.5376 9.53757 23 6.5 23C3.46243 23 1 20.5376 1 17.5C1 14.4624 3.46243 12 6.5 12C9.53757 12 12 14.4624 12 17.5ZM9.85355 15.1464C9.65829 14.9512 9.34171 14.9512 9.14645 15.1464L5.5 18.7929L3.85355 17.1464C3.65829 16.9512 3.34171 16.9512 3.14645 17.1464C2.95118 17.3417 2.95118 17.6583 3.14645 17.8536L5.14645 19.8536C5.34171 20.0488 5.65829 20.0488 5.85355 19.8536L9.85355 15.8536C10.0488 15.6583 10.0488 15.3417 9.85355 15.1464Z'
          fill='#404040'
        />
      </svg>
    ),
    label: 'imóveis analisados',
  },
];
const ConsumptionDetails = ({
  closeDrawer,
  idConsumption,
  indicator,
  typeProduct,
  exceedingEnvelopes,
}: IConsumptionDetails) => {
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [isExporting, setIsExporting] = useState(false);
  const [history, setHistory] = useState<any[]>([]);
  const fetchDataDailyQualification = async () => {
    setIsLoading(true);
    const startDate = moment(
      `${indicator.ano}-${indicator.mes}-01`,
      'YYYY-MM-DD',
    ).format('YYYY-MM-DD');
    let endDate;

    const currentMonth = moment().month() + 1; // Mês atual (1 baseado)
    const currentYear = moment().year(); // Ano atual

    // Verifica se o mês indicado é o mesmo do mês atual
    if (indicator.mes === currentMonth && indicator.ano === currentYear) {
      endDate = moment().format('YYYY-MM-DD'); // Usa o dia de hoje
    } else {
      // Caso contrário, usa o último dia do mês indicado
      endDate = moment(`${indicator.ano}-${indicator.mes}-01`)
        .endOf('month')
        .format('YYYY-MM-DD');
    }
    try {
      const { data } = await api.get(
        `qualifier/movto/debit/${idConsumption}?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&limit=${10}&type_product=${typeProduct}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      setHistory(prevState => {
        // Filtra os novos dados para garantir que não haja objetos duplicados
        const filteredData = data.data.filter(
          (newItem: any) =>
            !prevState.some(
              existingItem =>
                JSON.stringify(existingItem) === JSON.stringify(newItem),
            ),
        );

        return [...prevState, ...filteredData];
      });

      setTotalPages(data.pagination.pages);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchAllDataForExport = async () => {
    const startDate = moment(
      `${indicator.ano}-${indicator.mes}-01`,
      'YYYY-MM-DD',
    ).format('YYYY-MM-DD');
    let endDate;

    const currentMonth = moment().month() + 1; // Mês atual (1 baseado)
    const currentYear = moment().year(); // Ano atual

    // Verifica se o mês indicado é o mesmo do mês atual
    if (indicator.mes === currentMonth && indicator.ano === currentYear) {
      endDate = moment().format('YYYY-MM-DD'); // Usa o dia de hoje
    } else {
      // Caso contrário, usa o último dia do mês indicado
      endDate = moment(`${indicator.ano}-${indicator.mes}-01`)
        .endOf('month')
        .format('YYYY-MM-DD');
    }
    try {
      const { data } = await api.get(
        `qualifier/movto/debit/${idConsumption}/export?startDate=${startDate}&endDate=${endDate}&type_product=${typeProduct}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      return data.data;
    } catch (error) {
      console.log(error);
      return [];
    }
  };
  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const allData = await fetchAllDataForExport();

      if (allData.length === 0) {
        alert('Não há dados para exportar');
        return;
      }

      // Preparar os dados para o Excel
      const excelData = allData.map((item: any) => ({
        'Data de uso': moment(item.date).format('DD/MM/YYYY HH:mm'),
        Funcionalidade: item.type_transaction_description || '',
        Usuário: item.name_broker || '',
        'Consumo de koins': item.value * -1 || 0,
      }));

      // Criar workbook e worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Definir largura das colunas
      const columnWidths = [
        { wch: 25 }, // Data de uso
        { wch: 20 }, // Funcionalidade
        { wch: 15 }, // Usuário
        { wch: 18 }, // Consumo de koins
      ];
      worksheet['!cols'] = columnWidths;

      // Adicionar worksheet ao workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Consumo de koins');

      // Gerar nome do arquivo
      const monthName =
        moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
          .format('MMMM')
          .charAt(0)
          .toUpperCase() +
        moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
          .format('MMMM')
          .slice(1);

      const fileName = `Consumo_LYA_${monthName}_${indicator?.ano}.xlsx`;

      // Fazer download do arquivo
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      alert('Erro ao exportar dados. Tente novamente.');
    } finally {
      setIsExporting(false);
    }
  };
  useEffect(() => {
    fetchDataDailyQualification();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [indicator, idConsumption, currentPage]);

  const Loader = () => {
    return (
      <S.Loader>
        <img src={loadingSmall} />
      </S.Loader>
    );
  };

  const [nextPageDiv, setNextPageDiv] = useState<HTMLDivElement | null>(null);
  const showMoreHistory = () => {
    setCurrentPage(indicatorsPerPage => indicatorsPerPage + 1);
  };
  const nextPageDivCallback = useCallback((node: HTMLDivElement | null) => {
    setNextPageDiv(node);
  }, []);

  useEffect(() => {
    if (!nextPageDiv) return;

    const observer = new IntersectionObserver(
      entries => {
        const target = entries[0];
        if (target.isIntersecting && currentPage < totalPages) {
          showMoreHistory();
        }
      },
      {
        root: null,
        rootMargin: '20px',
        threshold: 0.1,
      },
    );

    observer.observe(nextPageDiv);

    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextPageDiv]);

  return (
    <DrawerComponent
      open
      size='default'
      // className={styles.drawer}
      onCompleteClose={closeDrawer}
      titleClose={'Consumo mensal'}
    >
      {isLoading && currentPage === 1 ? (
        <Loader />
      ) : (
        <>
          <S.WrapperInvoiceDetail>
            <span>
              {moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
                .format('MMMM')
                .charAt(0)
                .toUpperCase() +
                moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
                  .format('MMMM')
                  .slice(1)}{' '}
              de{' '}
              {moment(
                `${indicator?.ano}-${indicator?.mes}-01`,
                'YYYY-MM-DD',
              ).format('YYYY')}
            </span>
          </S.WrapperInvoiceDetail>
          <S.ContentDetails>
            <S.Box>
              <S.TextAside
                fontSize='16'
                fontWeight='700'
                style={{ marginBottom: '16px' }}
              >
                {indicator?.qtd_total_lya || 0} koins
              </S.TextAside>
              {(() => {
                const total = indicator?.qtd_total_lya || 0;
                const segments = categories.map(cat => {
                  const value = indicator?.[cat.key] || 0;
                  return {
                    ...cat,
                    value,
                    percentage: total > 0 ? (value / total) * 100 : 0,
                  };
                });

                return (
                  <S.CategoryList>
                    {segments.map(segment => (
                      <S.CategoryRow key={segment.key}>
                        <S.CategoryInfo>
                          <S.CategoryRow
                            key={segment.key}
                            style={{ justifyContent: 'space-between' }}
                          >
                            <S.CategoryRow style={{ width: 'fit-content' }}>
                              <S.CategoryIconWrapper>
                                {segment.icon}
                              </S.CategoryIconWrapper>
                              <S.CategoryName>
                                {segment.name} {Math.round(segment.percentage)}%
                              </S.CategoryName>
                            </S.CategoryRow>
                            <S.CategoryValue>
                              {segment.value}{' '}
                              {segment.value !== 1
                                ? segment.label
                                : segment.label
                                    .replace('s', '')
                                    .replace('es', '')}
                            </S.CategoryValue>
                          </S.CategoryRow>
                          <S.CategoryBarContainer>
                            <S.CategoryBar
                              width={segment.percentage}
                              color={segment.color}
                            />
                          </S.CategoryBarContainer>
                        </S.CategoryInfo>
                      </S.CategoryRow>
                    ))}
                  </S.CategoryList>
                );
              })()}
            </S.Box>
            <S.TextAside
              fontSize='16'
              fontWeight='700'
              style={{ marginBottom: '16px' }}
            >
              Saldo recebido
            </S.TextAside>
            <S.Box>
              <div
                style={{
                  display: 'flex',
                  gap: '16px',
                  justifyContent: 'space-between',
                }}
              >
                {' '}
                <S.TextAside fontSize='16' fontWeight='500'>
                  Koins do plano
                </S.TextAside>{' '}
                <S.TextAside fontSize='16' fontWeight='700'>
                  <InvoiceStatus
                    status={'venda'}
                    text={indicator?.qtd_creditos_recebidos}
                    icon={<KenloLiaIcon size={16} />}
                    colortText={theme.colors.neutral.neutral120}
                    fontWeight='500'
                  />
                </S.TextAside>
              </div>
              {(indicator.mes === moment().month() + 1
                ? exceedingEnvelopes
                : indicator?.qtd_debitos_negativos) > 0 ? (
                <>
                  <hr style={{ margin: '16px -24px' }} />
                  <div
                    style={{
                      display: 'flex',
                      gap: '16px',
                      justifyContent: 'space-between',
                    }}
                  >
                    {' '}
                    <S.TextAside fontSize='16' fontWeight='500'>
                      Koins adicionados
                    </S.TextAside>{' '}
                    <S.TextAside fontSize='16' fontWeight='700'>
                      <InvoiceStatus
                        status={'venda'}
                        text={
                          indicator.mes === moment().month() + 1
                            ? exceedingEnvelopes
                            : indicator?.qtd_debitos_negativos
                        }
                        icon={<KenloLiaIcon size={16} />}
                        colortText={theme.colors.neutral.neutral120}
                        fontWeight='500'
                      />
                    </S.TextAside>
                  </div>
                </>
              ) : (
                <></>
              )}
            </S.Box>
            <div
              style={{
                display: 'flex',
                gap: '16px',
                justifyContent: 'space-between',
                marginBottom: '16px',
              }}
            >
              <S.TextAside fontSize='16' fontWeight='700'>
                Koins utilizados
              </S.TextAside>
              <span
                onClick={
                  isExporting || history.length <= 0 ? undefined : exportToExcel
                }
                style={{
                  color:
                    isExporting || history.length <= 0
                      ? theme.colors.neutral.neutral50
                      : theme.colors.primary50,
                  cursor:
                    isExporting || history.length <= 0
                      ? 'not-allowed'
                      : 'pointer',
                  opacity: isExporting || history.length <= 0 ? 0.6 : 1,
                  pointerEvents:
                    isExporting || history.length <= 0 ? 'none' : 'auto',
                  fontSize: '16px !important',
                }}
              >
                <ToolTip
                  right='2rem'
                  height='3rem'
                  content={
                    isExporting
                      ? 'Download em andamento, aguarde...'
                      : 'Clique para fazer o download dos dados.'
                  }
                  icon={
                    <div style={{ marginLeft: '1rem' }}>
                      {isExporting ? <S.LoadingSpinner /> : <DownloadIcon />}
                    </div>
                  }
                  text={isExporting ? 'Exportando...' : 'Exportar'}
                />
              </span>
            </div>

            <S.Box>
              {history.length > 0 ? (
                history.map((el, index) => {
                  const category =
                    mapTransactionTypeToCategory(
                      el?.id_transaction_debit_type,
                    ) ||
                    el?.type ||
                    el?.category;
                  return (
                    <>
                      <CardDrawer
                        key={el?.id_debit}
                        name={el?.signature_name}
                        status={el?.signature_status}
                        broker={el?.name_broker}
                        date={el?.date}
                        value={el?.value}
                        type={category}
                        clientName={el?.use_description}
                        secondaryText={el?.type_transaction_description}
                        actionType={el?.use_description}
                      />

                      {index !== history.length - 1 && (
                        <hr style={{ margin: '16px -24px' }} />
                      )}
                    </>
                  );
                })
              ) : (
                <S.NotLeads>
                  <Hands />
                  <div>
                    <S.TitlePerfomace
                      color={theme.colors.neutral.neutral120}
                      fontWeight={600}
                      fontSize='2rem'
                      style={{ marginBottom: '8px' }}
                    >
                      Nenhum koins utilizado esse mês
                    </S.TitlePerfomace>
                    <S.SubtitlePerfomace
                      color={theme.colors.neutral.neutral120}
                      fontWeight={500}
                    >
                      Utilize os recursos da LYA para consumir koins.
                    </S.SubtitlePerfomace>
                  </div>
                </S.NotLeads>
              )}
            </S.Box>
            <div ref={nextPageDivCallback} />
          </S.ContentDetails>
        </>
      )}
    </DrawerComponent>
  );
};
export default ConsumptionDetails;
